import { OverviewFormProps } from "./OverviewForm.types"
import SectionType from "../../../../enums/sectionType"
import { ASSET_TYPES } from "../../../../utils/constants"
import "./OverviewForm.css"

const OverviewForm = (props: OverviewFormProps) => {
  const { workflow } = props

  return (
    <div className="overview-form-container">
      <h2>Workflow Overview</h2>
      <div className="overview-container">
        <h3>Workflow Details</h3>
        <div className="workflow-overview">
          <p>Workflow Filename:</p>
          <p>{workflow.filename}</p>
          <p>Asset ID:</p>
          <p>{workflow.asset_id}</p>
          <p>Asset Length:</p>
          <p>{workflow.asset_length}</p>
          <p>Asset Temperature:</p>
          <p>{workflow.asset_temp}</p>
          <p>Asset Diameter:</p>
          <p>{workflow.asset_diameter}</p>
          <p>Location</p>
          <p>{workflow.location}</p>
          <p>Asset type:</p>
          <p>{ASSET_TYPES[workflow.asset_type].name}</p>

          <p>Workflow start:</p>
          <p>{workflow.workflow_start}</p>
          <p>Workflow end:</p>
          <p>{workflow.workflow_end}</p>
          <p>Cladding material:</p>
          <p>{workflow.cladding_material}</p>
          <p>Cladding thickness:</p>
          <p>{workflow.cladding_thickness}</p>
          <p>Insulation material:</p>
          <p>{workflow.insulation_material}</p>
          <p>Insulation thickness:</p>
          <p>{workflow.insulation_thickness}</p>
          <p>Tracing cable present:</p>
          <p>{workflow.has_tracing_cable ? "YES" : "NO"}</p>
        </div>
      </div>

      {JSON.parse(workflow.sections).map((section: number[], index: number) => (
        <div className="overview-container">
          <h3>{`Section ${index+1}`}</h3>
          <div className="section-overview" key={index}>
            <p>Section type:</p>
            <p>{Object.values(SectionType)[section[2]]}</p>
            <p>Section start:</p>
            <p>{section[0]}</p>
            <p>Section end:</p>
            <p>{section[1]}</p>
            <p>Angles:</p>
            <p>{JSON.parse(workflow.angles)[index].map((angle: number) => `${angle}°, `)}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default OverviewForm